package com.essntl.features.message.ui.chat.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.itemsIndexed
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.selection.SelectionContainer
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import core.dateformat.utils.formatTimestamptzToDateFullString
import com.essntl.uikit.components.chat.message.EsMessage
import com.essntl.uikit.components.chat.message.EsSendMessageInput
import com.essntl.uikit.components.chat.message.MessageUiState
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography
import kotlinx.datetime.Clock

@Composable
fun ChatUi(
    messages: List<MessageUiState>,
    messagesHeader: @Composable () -> Unit = {},
    onSend: (String) -> Unit,
    onReact: (messageId: String, emoji: String?) -> Unit,
) {
    val currentDate = formatTimestamptzToDateFullString(Clock.System.now().epochSeconds.toString())
    var text by remember { mutableStateOf("") }

    Column(
        modifier = Modifier
            .fillMaxSize(),
        verticalArrangement = Arrangement.SpaceBetween,
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        messagesHeader()

        LazyColumn(
            reverseLayout = true,
            verticalArrangement = Arrangement.spacedBy(10.dp),
            contentPadding = PaddingValues(bottom = 20.dp),
            modifier = Modifier
                .weight(1f)
                .padding(
                    top = 10.dp,
                    start = 10.dp,
                    end = 10.dp,
                ),
        ) {
            itemsIndexed(messages) { index, message ->

                val isSameSender = index == 0 ||
                    messages[index - 1].isCurrentUserSender

                val date = formatTimestamptzToDateFullString(message.dateTime)
                val showDate = index == messages.lastIndex ||
                    formatTimestamptzToDateFullString(messages[index + 1].dateTime) != date

                SelectionContainer {
                    EsMessage(
                        message = message,
                        isSameSender = isSameSender,
                        senderName = message.senderName,
                        onReact = onReact,
                    )
                }

                if (showDate)
                    Box(
                        contentAlignment = Alignment.BottomCenter,
                        modifier = Modifier
                            .fillMaxWidth(),
                    ) {
                        Text(
                            if (date == currentDate) "Today" else date,
                            style = MaterialTheme.esTypography.p2Regular14
                                .copy(color = MaterialTheme.esColorScheme.textSecondary),
                            modifier = Modifier
                                .background(
                                    color = MaterialTheme.esColorScheme.bgSecondary,
                                    shape = RoundedCornerShape(12.dp),
                                )
                                .padding(horizontal = 15.dp, vertical = 10.dp),
                        )
                    }

            }
        }

        EsSendMessageInput(
            value = text,
            onValueChange = { text = it },
            onSend = onSend,
            modifier = Modifier
                .padding(
                    start = 10.dp,
                    end = 10.dp,
                    bottom = 10.dp,
                ),
        )
    }
}